module.exports = __webpack_public_path__ + "static/media/insentBotIcon.99939eef.png";